import styled from 'styled-components';

export const ApplicationItemContainerStyled = styled(`div`)`
	gap: 12px;
	display: flex;
	justify-content: center;
	padding: 0 16px;
	width: 100%;
	height: 88px;
	&:hover {
		background-color: #e6f7ff;
	}
`;
export const ApplicationItemLogoStyled = styled(`img`)`
	width: 64px;
	height: 64px;
	border: 0.725px solid #d9d9d9;
	border-radius: 6px;
`;

export const ApplicationItemTextContainerStyled = styled(`div`)`
	display: flex;
	flex-direction: column;
`;

export const ApplicationItemNameStyled = styled(`h3`)`
	gap: 12px;
	display: flex;
	align-items: center;
	margin-bottom: 3px;
	width: fit-content;
	color: #262626;
	font-weight: 500;
	font-size: 16px;
	line-height: 21px;
`;

export const ApplicationItemDeveloperStyled = styled(`div`)`
	color: #1890ff;
	font-weight: 600;
	font-size: 12px;
`;
export const ApplicationItemDescriptionStyled = styled(`div`)`
	color: #595959;
	font-weight: 300;
	font-size: 14px;
	line-height: 22px;
`;

export const ApplicationItemContentStyled = styled(`div`)`
	gap: 12px;
	display: flex;
	padding: 12px 0;
	width: 100%;
`;
